export default /[@#$%&+=^~[\]{};,’¡¿]/g;
